function getNewsFeed(url_news_json) {
    if(!url_news_json){
        return false;
    }
    $.ajax({
        dataType: "json",
        url: url_news_json,
        success: function (data) {
            $.each(data.posts, function( index, value ) {
                if (!$('.news_component_section_wrap .component_section_item:eq('+index+')')[0]) {
                        $('.news_component_section_wrap').append($('.news_component_section_wrap .component_section_item:eq('+(index-1)+')').clone());
                }
                $('.news_component_section_wrap .component_section_item:last h3').html(value.title );
                $('.news_component_section_wrap .component_section_item:last .js-news-body').html(value.excerpt);

                $('.news_component_section_wrap .component_section_item:last .component_section_picture img').attr('src', value.thumbnail_images.full.url );
                $('.news_component_section_wrap .component_section_item:last .js-link-tonews, .component_section .component_section_item:last .component_section_picture .js-link-tonews').attr('href', value.url );
                $('.news_component_section_wrap .component_section_item:last .news_date em').html(moment(value.date).format("DD MMMM YYYY"));              
                
                if(index == 2) {
                    return false;
                }
            });
        }
    });
}